export function setOptionObjectValue($, value) {
    $._value = value;
}
export function getOptionObjectValue($) {
    return $._value;
}
export function getInputValue($) {
    if ($.nodeName === 'INPUT') {
        if ($.type === 'number') {
            return parseFloat($.value);
        }
        else if ($.type === 'checkbox' || $.type === 'radio') {
            return $.checked;
        }
        else {
            return $.value;
        }
    }
    else if ($.nodeName === 'SELECT') {
        const s = $;
        const selected = Array.from(s.selectedOptions).map(option => getOptionObjectValue(option)
            || option.value
            || option.text);
        return s.multiple ? selected : selected[0];
    }
    else {
        return $.value;
    }
}
export function setInputValue($, value) {
    if ($.nodeName === 'INPUT') {
        if ($.type === 'checkbox' || $.type === 'radio') {
            $.checked = !!value;
        }
        else {
            $.value = value;
        }
    }
    else if ($.nodeName === 'SELECT') {
        const s = $;
        const selected = Array.isArray(value) ? value : [value];
        Array.from(s.options).forEach(option => {
            option.selected = ((getOptionObjectValue(option) && selected.includes(getOptionObjectValue(option)))
                || (option.value && selected.includes(option.value))
                || (!option.value && selected.includes(option.text)));
        });
    }
    else {
        $.value = value;
    }
}
//# sourceMappingURL=input-value.js.map